import React, { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";
import { trackEvent } from "../utils/analytics";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    // Track the scroll to top action
    trackEvent('scroll_to_top', {
      category: 'user_interaction',
      action: 'scroll_to_top_click',
      label: 'scroll_button',
      value: 1
    });

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-50 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white p-3 rounded-full shadow-lg shadow-red-500/25 transition-all duration-300 transform hover:scale-110 border border-red-500/30 group"
          aria-label="Scroll to top"
        >
          <ChevronUp className="w-5 h-5 group-hover:animate-bounce" />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;